import { DxoUiTextBanner } from './src/DxoUiTextBanner.js';

if (!window.customElements.get('dxo-ui-text-banner')) {
  window.customElements.define('dxo-ui-text-banner', DxoUiTextBanner as any);
}
